{
  "INBOX_MGMT": {
    "HEADER": "Вхідні",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Підключити знову",
      "FACEBOOK": "Термін дії підключення до Facebook минув, або його відкликали. Повідомлення на сторінку не надходять у ці вхідні, а відповіді можуть не надіслатися. Людина, яка керує сторінкою Facebook, має натиснути «Підключити знову» й увійти у Facebook.",
      "INSTAGRAM": "Термін дії підключення до Instagram минув, або його відкликали. Повідомлення на акаунт не надходять у ці вхідні, а відповіді можуть не надіслатися. Натисніть «Підключити знову» й увійдіть у той самий акаунт Instagram. Інший акаунт створить нові вхідні.",
      "GOOGLE": "Термін дії підключення до Google минув, або його відкликали. Нові листи не надходять у ці вхідні, а відповіді можуть не надіслатися. Натисніть «Підключити знову» й увійдіть у Google як {email}.",
      "MICROSOFT": "Термін дії підключення до Microsoft минув, або його відкликали. Нові листи не надходять у ці вхідні, а відповіді можуть не надіслатися. Натисніть «Підключити знову» й увійдіть у Microsoft як {email}.",
      "ALLEGRO": "Термін дії підключення до Allegro минув, або його відкликали. Повідомлення від покупців не надходять у ці вхідні, а відповіді можуть не надіслатися. Натисніть «Підключити знову» й увійдіть в Allegro як продавець {seller}. Інший акаунт продавця створить нові вхідні.",
      "IMAP_LOGIN": "Поштовий сервер відхиляє вхід до IMAP як {login}. Нові листи не надходять до цієї скриньки. Перевірте логін і пароль для IMAP на вкладці {tab} та збережіть їх. Ми й далі пробуємо увійти, і скринька відновиться, щойно вхід спрацює.",
      "WHATSAPP": "З'єднання з WhatsApp завершилося або було відкликане. Вкладення від клієнтів не надходять до цієї скриньки, а відповіді можуть не надсилатися. Натисніть «Підключити знову», увійдіть у Facebook і знову виберіть номер {phone}."
    },
    "LIST": {
      "404": "В цього облікового запису немає скриньк.",
      "RECONNECT_REQUIRED": "Потрібно повторно підключити"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Оберіть канал",
        "BODY": "Виберіть постачальника, якого ви хочете інтегрувати з чатом."
      },
      "INBOX": {
        "TITLE": "Створити вхідну скриньку",
        "BODY": "Увійдіть до свого облікового запису і створіть \"Джерело\"."
      },
      "AGENT": {
        "TITLE": "Додати агентів",
        "BODY": "Додати агентів до створеного \"Джерела\"."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Все готово!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Назва Джерела",
        "PLACEHOLDER": "Введіть назву свого Джерела (наприклад: Acme Inc)",
        "ERROR": "Будь ласка, введіть припустиме ім'я вхідної скриньки"
      },
      "WEBSITE_NAME": {
        "LABEL": "Назва сайту",
        "PLACEHOLDER": "Введіть назву свого сайту (наприклад: Acme Inc)"
      },
      "FB": {
        "HELP": "PS: Після авторизації ми отримаємо доступ лише до ваших повідомлень на сторінці. Ваші особисті повідомлення ніколи не будуть нам доступні.",
        "CHOOSE_PAGE": "Вибрати сторінку",
        "CHOOSE_PLACEHOLDER": "Виберіть сторінку зі списку",
        "INBOX_NAME": "Назва Джерела",
        "ADD_NAME": "Додайте назву Джерела",
        "PICK_NAME": "Виберіть ім'я для вхідних",
        "PICK_A_VALUE": "Виберіть значення",
        "CREATE_INBOX": "Створити інбокс"
      },
      "TWITTER": {
        "HELP": "Щоб додати свій профіль у Twitter як канал, вам потрібно авторизувати свій профіль у Twitter, натиснувши кнопку \"Увійти через Twitter\" ",
        "ERROR_MESSAGE": "Помилка підключення до Twitter, будь ласка, спробуйте ще раз",
        "TWEETS": {
          "ENABLE": "Створити розмову зі згаданих твітів"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Канал Веб-сайт",
        "DESC": "Створіть канал для свого сайту та почніть підтримувати своїх клієнтів за допомогою нашого віджету.",
        "LOADING_MESSAGE": "Створення каналу підтримки веб-сайту",
        "CHANNEL_AVATAR": {
          "LABEL": "Аватар каналу"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "URL вебхука",
          "PLACEHOLDER": "Будь ласка, введіть URL вашого вебхука",
          "ERROR": "Будь ласка, введіть правильний URL"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Домен сайту",
          "PLACEHOLDER": "Введіть домен вашого сайту (наприклад: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Заголовок",
          "PLACEHOLDER": "Привіт!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Талін привітання",
          "PLACEHOLDER": "Ми робимо простим зв'язок з нами. Запитайте нас що-небудь або поділіться своїми відгуками."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Вітання каналу",
          "PLACEHOLDER": "Acme Inc зазвичай відповідає за кілька годин."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Увімкнути вітання каналу",
          "HELP_TEXT": "Автоматично надсилати привітальне повідомлення після створення нової розмови.",
          "ENABLED": "Увімкнено",
          "DISABLED": "Вимкнено"
        },
        "REPLY_TIME": {
          "TITLE": "Встановити час відповіді",
          "IN_A_FEW_MINUTES": "За кілька хвилин",
          "IN_A_FEW_HOURS": "За кілька годин",
          "IN_A_DAY": "Протягом дня",
          "HELP_TEXT": "Цей час відповіді буде показуватися на віджеті онлайн чату"
        },
        "WIDGET_COLOR": {
          "LABEL": "Колір віджета",
          "PLACEHOLDER": "Оновити колір віджета"
        },
        "SUBMIT_BUTTON": "Створити скриньку \"Вхідні\"",
        "API": {
          "ERROR_MESSAGE": "Ми не змогли створити канал сайту, будь ласка, спробуйте ще раз"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp канал",
        "DESC": "Інтегруйте Twilio та починайте підтримувати своїх клієнтів через SMS чи WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "SID облікового запису",
          "PLACEHOLDER": "Будь ласка, введіть SID облікового запису Twilio",
          "ERROR": "Це поле є обов'язковим"
        },
        "API_KEY": {
          "USE_API_KEY": "Використовувати API Key автентифікацію",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Будь ласка, введіть ваш API Key SID",
          "ERROR": "Це поле є обов'язковим"
        },
        "API_KEY_SECRET": {
          "LABEL": "Секретний ключ API",
          "PLACEHOLDER": "Будь ласка, введіть ваш ключ API",
          "ERROR": "Це поле є обов'язковим"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Служба обміну повідомленнями SID",
          "PLACEHOLDER": "Будь ласка, введіть свій Twilio Messaging Service SID",
          "ERROR": "Це поле є обов'язковим",
          "USE_MESSAGING_SERVICE": "Використовувати Twilio Messaging Service"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Тип каналу",
          "ERROR": "Будь ласка, оберіть тип вашого каналу"
        },
        "AUTH_TOKEN": {
          "LABEL": "Токен автентифікації",
          "PLACEHOLDER": "Введіть ваш Twilio Auth токен",
          "ERROR": "Це поле є обов'язковим"
        },
        "CHANNEL_NAME": {
          "LABEL": "Назва каналу",
          "PLACEHOLDER": "Будь ласка, введіть назву каналу",
          "ERROR": "Це поле є обов'язковим"
        },
        "PHONE_NUMBER": {
          "LABEL": "Номер телефону",
          "PLACEHOLDER": "Будь ласка, введіть номер телефону, з якого будуть надсилатися повідомлення.",
          "ERROR": "Будь ласка, надайте дійсний номер телефону, який починається зі знаку \"+\", і не містить пробілів."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Ви повинні налаштувати URL зворотнього виклику у Twilio з URL-адресою, згаданим тут."
        },
        "SUBMIT_BUTTON": "Створити Twilio канал",
        "API": {
          "ERROR_MESSAGE": "Автентифікація у Twilio не вдалася, будь ласка, спробуйте знову"
        }
      },
      "SMS": {
        "TITLE": "SMS-канал",
        "DESC": "Розпочніть підтримувати ваших клієнтів через SMS.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "Ми не змогли зберегти SMS-канал"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID акаунту",
            "PLACEHOLDER": "Будь ласка, введіть ваш Ідентифікатор облікового запису Bandwidth",
            "ERROR": "Це поле є обов'язковим"
          },
          "API_KEY": {
            "LABEL": "API ключ",
            "PLACEHOLDER": "Будь ласка, введіть ваш API ключ Bandwidth",
            "ERROR": "Це поле є обов'язковим"
          },
          "API_SECRET": {
            "LABEL": "Секретний Ключ API",
            "PLACEHOLDER": "Будь ласка, введіть ваш секретний ключ API Bandwidth",
            "ERROR": "Це поле є обов'язковим"
          },
          "APPLICATION_ID": {
            "LABEL": "ID додатку",
            "PLACEHOLDER": "Будь ласка, введіть ваш ID додатка Bandwidth",
            "ERROR": "Це поле є обов'язковим"
          },
          "INBOX_NAME": {
            "LABEL": "Назва каналу",
            "PLACEHOLDER": "Будь ласка, введіть назву каналу",
            "ERROR": "Це поле є обов'язковим"
          },
          "PHONE_NUMBER": {
            "LABEL": "Номер телефону",
            "PLACEHOLDER": "Будь ласка, введіть номер телефону, з якого будуть надсилатися повідомлення.",
            "ERROR": "Будь ласка, надайте дійсний номер телефону, який починається зі знаку \"+\", і не містить пробілів."
          },
          "SUBMIT_BUTTON": "Створити Bandwidth канал",
          "API": {
            "ERROR_MESSAGE": "Ми не змогли авторизувати облікові дані Bandwidth, будь ласка, спробуйте ще раз"
          },
          "API_CALLBACK": {
            "TITLE": "Callback URL",
            "SUBTITLE": "Ви повинні налаштувати URL зворотнього виклику у Bandwidth з URL-адресою, згаданим тут."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Назва інбоксу",
            "PLACEHOLDER": "Будь ласка, введіть назву інбоксу",
            "ERROR": "Це поле є обов'язковим"
          },
          "PHONE_NUMBER": {
            "LABEL": "Номер телефону",
            "PLACEHOLDER": "Будь ласка, введіть номер телефону, з якого надсилатимуться повідомлення.",
            "ERROR": "Будь ласка, вкажіть дійсний номер телефону, що починається зі знаку «+»."
          },
          "SUBMIT_BUTTON": "Створити канал SMS Brana",
          "API": {
            "ERROR_MESSAGE": "Нам не вдалося створити канал SMS Brana"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Назва інбоксу",
            "PLACEHOLDER": "Будь ласка, введіть назву інбоксу",
            "ERROR": "Це поле є обов'язковим"
          },
          "PHONE_NUMBER": {
            "LABEL": "Номер телефону",
            "PLACEHOLDER": "Будь ласка, введіть номер телефону, з якого надсилатимуться повідомлення.",
            "ERROR": "Будь ласка, вкажіть дійсний номер телефону, що починається зі знаку «+»."
          },
          "SUBMIT_BUTTON": "Створити канал DIDWW",
          "API": {
            "ERROR_MESSAGE": "Нам не вдалося створити канал DIDWW"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API Provider",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "Ви повинні налаштувати URL вебхука і токен перевірки на порталі розробників Facebook зі значеннями, що вказані нижче.",
          "WEBHOOK_URL": "URL вебхука",
          "WEBHOOK_VERIFICATION_TOKEN": "Токен вебхука"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Швидке налаштування з Meta",
          "DESC": "Вас буде перенаправлено на сайт Meta, щоб увійти у свій обліковий запис WhatsApp Business. Права адміністратора допоможуть зробити налаштування простим і швидким.",
          "BENEFITS": {
            "EASY_SETUP": "Ручне налаштування не потрібне",
            "SECURE_AUTH": "Безпечна автентифікація на основі OAuth",
            "AUTO_CONFIG": "Автоматичне налаштування вебхука та номера телефону"
          },
          "SUBMIT_BUTTON": "Підключити WhatsApp Business",
          "AUTH_PROCESSING": "Автентифікація в Meta",
          "WAITING_FOR_BUSINESS_INFO": "Будь ласка, завершіть налаштування бізнес-акаунту у вікні Meta...",
          "PROCESSING": "Налаштування вашого облікового запису WhatsApp Business",
          "CANCELLED": "Реєстрацію WhatsApp скасовано",
          "WAITING_FOR_AUTH": "Очікування автентифікації...",
          "INVALID_BUSINESS_DATA": "Отримано недопустимі дані бізнес-акаунту від Facebook. Будь ласка, спробуйте ще раз.",
          "SIGNUP_ERROR": "Сталася помилка реєстрації",
          "SDK_LOAD_ERROR": "Не вдалося завантажити Facebook SDK. Спробуйте ще раз.",
          "AUTH_NOT_COMPLETED": "Автентифікацію не завершено. Будь ласка, почніть процес спочатку.",
          "SUCCESS_FALLBACK": "Обліковий запис WhatsApp Business успішно налаштовано",
          "RECONNECTED": "Канал WhatsApp успішно перепідключено"
        },
        "API": {
          "ERROR_MESSAGE": "Ми не змогли зберегти канал WhatsApp"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API канал",
        "DESC": "Інтегруйте з API каналом і почніть підтримувати клієнтів.",
        "CHANNEL_NAME": {
          "LABEL": "Назва каналу",
          "PLACEHOLDER": "Будь ласка, введіть назву каналу",
          "ERROR": "Це поле є обов'язковим"
        },
        "WEBHOOK_URL": {
          "LABEL": "URL вебхука",
          "SUBTITLE": "Налаштуйте URL, де бажаєте відкликати події та приймати виклики.",
          "PLACEHOLDER": "URL вебхука"
        },
        "SUBMIT_BUTTON": "Створити API канал",
        "API": {
          "ERROR_MESSAGE": "Ми не змогли зберегти канал api"
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Email канал",
        "DESC": "Інтегруйте вашу поштову скриньку.",
        "CHANNEL_NAME": {
          "LABEL": "Назва каналу",
          "PLACEHOLDER": "Будь ласка, введіть назву каналу",
          "ERROR": "Це поле є обов'язковим"
        },
        "EMAIL": {
          "LABEL": "Email",
          "SUBTITLE": "Вкажіть адресу електронної пошти, на яку клієнти надсилають запити про підтримку.",
          "PLACEHOLDER": "Email"
        },
        "SUBMIT_BUTTON": "Створити Канал E-mail",
        "API": {
          "ERROR_MESSAGE": "Ми не змогли зберегти email канал"
        },
        "FINISH_MESSAGE": "Почніть перенаправляти листи до наступної адреси електронної пошти."
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE Канал",
        "DESC": "Інтегруйте канал LINE і почніть підтримувати клієнтів.",
        "CHANNEL_NAME": {
          "LABEL": "Назва каналу",
          "PLACEHOLDER": "Будь ласка, введіть назву каналу",
          "ERROR": "Це поле є обов'язковим"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "Ідентифікатор LINE Каналу",
          "PLACEHOLDER": "Ідентифікатор LINE Каналу"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "Секретний ключ LINE каналу",
          "PLACEHOLDER": "Секретний ключ LINE каналу"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "Токен каналу LINE",
          "PLACEHOLDER": "Токен каналу LINE"
        },
        "SUBMIT_BUTTON": "Створити LINE канал",
        "API": {
          "ERROR_MESSAGE": "Ми не змогли зберегти канал LINE"
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Необхідно налаштувати URL вебхука у додатку LINE за допомогою URL, згаданого тут."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Канал Telegram",
        "DESC": "Інтегруйте з Telegram каналом і починайте підтримувати клієнтів.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "Налаштуйте токен бота, який ви отримали з Telegram BotFather.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "Створити канал Telegram",
        "API": {
          "ERROR_MESSAGE": "Ми не змогли зберегти Telegram канал"
        }
      },
      "AUTH": {
        "TITLE": "Оберіть канал",
        "DESC": "Чат підтримує live-chat віджети, Facebook Messenger, WhatsApp, електронну пошту і т.д. Якщо ви хочете створити користувальницький канал, ви можете створити його за допомогою каналу API. Щоб почати, виберіть один з каналів нижче."
      },
      "AGENTS": {
        "TITLE": "Агенти",
        "DESC": "Тут Ви можете додавати агентів для керування нещодавно створеним джерелом. Тільки ці обрані агенти матимуть доступ до Вашої папки \"Вхідні\". Агенти, які не входять до цього джерела, не зможуть побачити або відповісти на повідомлення у цій папці \"Вхідні\", під час входу. <br> <b>PS:</b> Як адміністратор, якщо вам потрібен доступ до всіх джерел, ви повинні додати себе як агент до всіх \"Вхідні\", що створюєте.",
        "VALIDATION_ERROR": "Додайте принаймні один агент до вашої нової папки Вхідні",
        "PICK_AGENTS": "Вибрати агентів для джерела"
      },
      "DETAILS": {
        "TITLE": "Деталі скриньки Вхідні",
        "DESC": "З випадаючого списку виберіть сторінку Facebook, яку ви хочете підключити до чату. Ви також можете надати довільне ім'я для вашого джерела для кращої ідентифікації."
      },
      "FINISH": {
        "TITLE": "Успіх!",
        "DESC": "Ви успішно закінчили інтеграцію вашої сторінки у Facebook з чатом. Наступного разу, коли з’явиться клієнтська сторінка, розмова автоматично з'явиться у вашій поштовій скриньці.<br>Ми також надаємо вам сценарій роботи віджетів, який можна легко додати на ваш сайт. Як тільки це буде опубліковане на вашому сайті, клієнти можуть надсилати вам повідомлення прямо з вашого сайту без допомоги будь-якого зовнішнього інструменту, і розмова з'явиться тут, у чаті.<br>Круто, так? Ну, ми дійсно намагаємося бути :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Виберіть email провайдера",
        "DESCRIPTION": "Виберіть зі списку провайдера. Якщо Ви не бачите e-mail провайдера в списку, ви можете обрати іншого постачальника і надати IMAP та SMTP дані."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Натисніть на кнопку входу через Microsoft для початку. Ви будете перенаправлені на сторінку входу в систему. Як тільки ви приймете запитані дозволи, ви будете перенаправлені на сторінку створення вхідних повідомлень.",
        "EMAIL_PLACEHOLDER": "Некоректна адреса ел. пошти",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "Сталася помилка підключення до Microsoft, будь ласка, спробуйте ще раз"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Некоректна адреса ел. пошти",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      },
      "INTERNAL_NAME": {
        "LABEL": "Внутрішня назва",
        "PLACEHOLDER": "Назвіть інбокс, як він відображатиметься в цій панелі",
        "ERROR": "Будь ласка, введіть унікальну внутрішню назву"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Продовжити з Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Підключіть свій профіль Instagram",
        "HELP": "Щоб додати профіль Instagram як канал, вам потрібно автентифікувати свій профіль Instagram, натиснувши «Продовжити з Instagram» ",
        "ERROR_MESSAGE": "Виникла помилка під час підключення до Instagram, будь ласка, спробуйте ще раз",
        "ERROR_AUTH": "Виникла помилка під час підключення до Instagram, будь ласка, спробуйте ще раз",
        "NEW_INBOX_SUGGESTION": "Цей обліковий запис Instagram раніше був прив'язаний до іншого інбоксу і тепер перенесений сюди. Усі нові повідомлення з'являтимуться тут. Старий інбокс більше не зможе надсилати чи отримувати повідомлення для цього облікового запису.",
        "DUPLICATE_INBOX_BANNER": "Цей обліковий запис Instagram було перенесено до нового інбоксу каналу Instagram. Ви більше не зможете надсилати/отримувати повідомлення Instagram з цього інбоксу."
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Канал Salesforce",
        "DESC": "Інтегруйтеся з каналом Salesforce і розпочніть підтримку ваших клієнтів.",
        "CHANNEL_NAME": {
          "LABEL": "Назва каналу",
          "PLACEHOLDER": "Будь ласка, введіть назву каналу",
          "ERROR": "Це поле є обов'язковим"
        },
        "API_BASE_URL": {
          "LABEL": "URL Salesforce API",
          "SUBTITLE": "Налаштуйте базовий URL для вашого екземпляра Salesforce.",
          "PLACEHOLDER": "URL Salesforce API",
          "ERROR": "Це поле є обов'язковим"
        },
        "KEY_ID": {
          "LABEL": "Key ID",
          "SUBTITLE": "Key ID для вашого каналу Salesforce.",
          "PLACEHOLDER": "KEY ID",
          "ERROR": "Це поле є обов'язковим"
        },
        "SECRET": {
          "LABEL": "Secret",
          "SUBTITLE": "Secret для вашого каналу Salesforce.",
          "PLACEHOLDER": "*****",
          "ERROR": "Це поле є обов'язковим"
        },
        "SUBMIT_BUTTON": "Створити канал Salesforce",
        "API": {
          "ERROR_MESSAGE": "Нам не вдалося зберегти канал Salesforce"
        },
        "API_CALLBACK": {
          "TITLE": "URL webhook",
          "SUBTITLE": "Ви маєте налаштувати URL webhook у Salesforce з URL, вказаним тут."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer Token",
          "SUBTITLE": "Використовуйте цей bearer token для автентифікації під час налаштування webhook у Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Перевизначення відправника email",
          "SUBTITLE": "Якщо встановлено, ця email-адреса використовуватиметься як відправник для всіх вихідних email замість email-адреси джерела розмови.",
          "PLACEHOLDER": "наприклад, support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Канал Allegro",
        "DESC": "Підключіть обліковий запис продавця Allegro та відповідайте на повідомлення з його центру повідомлень у контакт-центрі.",
        "CHANNEL_NAME": {
          "LABEL": "Назва скриньки",
          "SUBTITLE": "Назва, яку агенти бачать для цієї скриньки.",
          "PLACEHOLDER": "Введіть назву скриньки",
          "ERROR": "Це поле є обов'язковим"
        },
        "SUBMIT_BUTTON": "Увійти через Allegro",
        "API": {
          "ERROR_MESSAGE": "Під час підключення до Allegro сталася помилка, спробуйте ще раз"
        },
        "SELLER_LOGIN": {
          "TITLE": "Вхід до Allegro",
          "SUBTITLE": "Обліковий запис продавця, повідомлення якого ця скринька читає та на які відповідає."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Канал Kaufland",
        "DESC": "Відповідайте на повідомлення в тікетах, які покупці надсилають вам на маркетплейсі Kaufland.",
        "CHANNEL_NAME": {
          "LABEL": "Назва каналу",
          "PLACEHOLDER": "Будь ласка, введіть назву каналу",
          "ERROR": "Це поле є обов'язковим"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "Client Key із 32 символів зі сторінки налаштувань API вашого облікового запису продавця Kaufland.",
          "PLACEHOLDER": "ключ із 32 символів",
          "ERROR": "Введіть Client Key із 32 символів"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "Secret Key із 64 символів, який належить до Client Key. Kaufland показує його один раз і ніколи не надсилає назад на цю сторінку.",
          "PLACEHOLDER": "ключ із 64 символів",
          "ERROR": "Введіть Secret Key із 64 символів"
        },
        "SUBMIT_BUTTON": "Створити канал Kaufland",
        "API": {
          "ERROR_MESSAGE": "Ми не змогли зберегти канал Kaufland"
        },
        "DISCONNECTED": {
          "TITLE": "Відключено",
          "MESSAGE": "Kaufland відхилив ці API-ключі. Введіть Client Key і Secret Key ще раз, щоб знову підключити цю скриньку."
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Телефонні виклики",
        "DESC": "Налаштуйте, які телефонні виклики відображатимуться під цим інбоксом.",
        "NAME": {
          "LABEL": "Назва інбоксу",
          "SUBTITLE": "Виберіть легко впізнавану назву."
        },
        "PHONE_NUMBER": {
          "LABEL": "Номер телефону",
          "SUBTITLE": "Введіть номери телефонів, що належать до цього інбоксу, ви можете додати більше номерів пізніше.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Створити інбокс телефонних викликів",
        "API": {
          "ERROR_MESSAGE": "Нам не вдалося створити інбокс"
        }
      }
    },
    "DETAILS": {
      "LOADING_FB": "Автентифікація через Facebook...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Щось пішло не так. Будь ласка, оновіть сторінку...",
      "ERROR_FB_UNAUTHORIZED": "Ви не авторизовані для цієї дії. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Переконайтеся, що ви маєте доступ до сторінки Facebook із повним доступом. Ви можете прочитати більше про ролі Facebook <a href=\" https://www.facebook.com/help/187316341316631\">тут</a>.",
      "ERROR_CHANNEL_CREATION": "Не вдалося створити скриньку \"Вхідні\". Будь ласка, спробуйте ще раз.",
      "CREATING_CHANNEL": "Створення скриньки Вхідні...",
      "TITLE": "Налаштувати подробиці Джерела",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Додати агентів",
      "ADD_AGENTS": "Додавання агентів до таки Вхідні..."
    },
    "FINISH": {
      "TITLE": "Ваша поштова скринька готова!",
      "MESSAGE": "Ви тепер можете взаємодіяти з вашими клієнтами через ваш новий канал. Щасливої підтримки",
      "BUTTON_TEXT": "Давай туди",
      "MORE_SETTINGS": "Додаткові налаштування",
      "WEBSITE_SUCCESS": "Ви успішно завершили створення каналу Веб-сайт. Скопіюйте наведений нижче код і вставте його на ваш сайт. Наступного разу коли клієнт скористається онлайн чатом, розмова автоматично з'явиться в вашій скриньці Вхідні."
    },
    "REAUTH": "Повторна авторизація",
    "VIEW": "Вигляд",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Налаштування вхідних повідомлень успішно оновлені",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Автопризначення успішно оновлено",
        "ERROR_MESSAGE": "Ми не змогли оновити параметри \"Вхідні\". Будь ласка, повторіть спробу пізніше."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Увімкнено",
        "DISABLED": "Вимкнено"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Увімкнено",
        "DISABLED": "Вимкнено"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Ім'я відправника",
        "SUB_TEXT": "Виберіть ім'я, що відображається вашому клієнту, коли він отримує повідомлення від ваших агентів.",
        "FOR_EG": "Наприклад:",
        "FRIENDLY": {
          "TITLE": "Дружній",
          "FROM": "від",
          "SUBTITLE": "Додайте ім'я агента, який надіслав відповідь в ім'я відправника, щоб зробити його привітним."
        },
        "PROFESSIONAL": {
          "TITLE": "Професійний",
          "SUBTITLE": "Використовувати лише налаштовану бізнес-назву як ім'я відправника в заголовку електронної пошти."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Налаштуйте ваше корпоративне ім'я",
          "PLACEHOLDER": "Введіть ваше корпоративне ім'я",
          "SAVE_BUTTON_TEXT": "Зберегти"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Увімкнено",
        "DISABLED": "Вимкнено"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Увімкнено",
        "DISABLED": "Вимкнено"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Немає"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Увімкнено",
        "DISABLED": "Вимкнено"
      },
      "ENABLE_HMAC": {
        "LABEL": "Увімкнено"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Увімкнено",
        "DISABLED": "Вимкнено"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Увімкнено",
        "DISABLED": "Вимкнено"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Увімкнено",
        "DISABLED": "Вимкнено"
      },
      "SHOW_WELCOME_SCREEN": {
        "ENABLED": "Увімкнено",
        "DISABLED": "Вимкнено"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Увімкнути синхронізацію вхідних листів"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Увімкнути користувацький email-домен (платна послуга)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Увімкнути обробку коментарів Facebook"
      },
      "SIGNATURE": {
        "TITLE": "HTML-підпис",
        "SUB_TEXT": "Цей підпис буде додано до нижньої частини кожного повідомлення, надісланого з цього інбоксу.",
        "HTML_CONTENT": "HTML-код",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} буде замінено на ім'я агента.\n{'{{'}email{'}}'} буде замінено на email-адресу агента, який надіслав лист.\n{'{{'}position{'}}'} буде замінено на посаду агента.\n{'{{'}custom_line{'}}'} буде замінено на додатковий рядок агента.\n{'{{'}email_signature_picture{'}}'} буде замінено на URL-адресу зображення email-підпису агента (а не на тег зображення) — використовуйте його як джерело зображення (атрибут src тега img).",
        "PREVIEW": "Попередній перегляд"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Підписи за країнами",
        "SUB_TEXT": "Відповідь підписується за країною покупця.",
        "HELP": "Відповідь підписується за країною діалогу: за магазином Kaufland, за маркетплейсом замовлення Allegro, а інакше за мовою, якою пише покупець. Якщо країну невідомо або для неї тут немає підпису, використовується HTML-підпис вище. Маркетплейси забороняють посилання на ваш сайт і контактні дані, тому залиште лише привітання та {'{{'}name{'}}'}.",
        "EMPTY": "У вас ще немає підписів для країн, тому відповіді підписуються HTML-підписом вище.",
        "COUNTRY": "Виберіть країну",
        "ADD": "Додати підпис для країни",
        "REMOVE": "Видалити"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Префікс набору телефонного номера",
        "PLACEHOLDER": "Введіть префікс для правильної маршрутизації викликів (наприклад, *99)",
        "HELP_TEXT": "Цей префікс автоматично додаватиметься до номерів телефонів контактів при наборі з цього інбоксу."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Текст кнопки «Вирішимо пізніше»",
        "PLACEHOLDER": "напр. Цю тему вирішимо електронною поштою. Зараз хочу запитати про щось інше.",
        "HELP_TEXT": "Текст кнопки у віджеті, за допомогою якої відвідувач залишає поточну тему й запитує про щось інше. Якщо залишити поле порожнім, використовуватиметься типовий текст мовою відвідувача."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Автовідкладення пропущених викликів на X хвилин",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Автоматично відкладати пропущені виклики на вказану кількість хвилин. Залиште порожнім або 0, щоб вимкнути."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Вирішувати пропущений виклик після X невдалих передзвонів",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Якщо на пропущений виклик передзвонили X разів, а клієнт не відповів, він автоматично вирішується, і до нього додається приватна нотатка. Залиште порожнім або 0, щоб вимкнути."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Пропозиції питань",
        "SUB_TEXT": "Налаштуйте попередньо визначені питання, які клієнти можуть використовувати для взаємодії з вашими агентами.",
        "QUESTIONS_LABEL": "Питання",
        "ADD_QUESTION": "Додати питання",
        "QUESTION": "Питання",
        "REMOVE": "Видалити",
        "QUESTION_TEXT": "Текст, що відображається у бульбашці.",
        "QUESTION_TEXT_PLACEHOLDER": "Обов'язково",
        "QUESTION_PAYLOAD": "Текст, що надсилається при натисканні.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Необов'язково",
        "SAVE": "Зберегти",
        "NO_BOT_MESSAGE": "Щоб генерувати додаткові пропозиції ШІ, будь ласка, підключіть бота.",
        "BOT_CONNECTED_MESSAGE": "Пропозиції питань ШІ від бота можна активувати в його",
        "BOT_SETTINGS_LINK": "налаштуваннях"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Альтернативні адреси електронної пошти",
        "SUB_TEXT": "Додаткові адреси, які ця скринька має вважати своїми під час отримання пересланої пошти.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Додати",
        "REMOVE": "Видалити",
        "EMPTY": "Альтернативні адреси електронної пошти не налаштовані.",
        "HELP_TEXT": "Коли лист надходить на одну з цих адрес як отримувача, відповіді надсилатимуться з тієї самої адреси як відправника. Переконайтеся, що ваш вихідний SMTP-сервер дозволяє надсилання з цих адрес.",
        "SIGNATURE_LABEL": "Підпис",
        "PRIMARY_SIGNATURE": "Основний (за замовчуванням)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Додаткові підписи",
        "SUB_TEXT": "Визначте тут додаткові підписи, а потім призначте їх альтернативним адресам нижче.",
        "OPTION": "Підпис {number}",
        "ADD": "Додати підпис",
        "REMOVE": "Видалити",
        "HELP_TEXT": "Коли відповідь надсилається з альтернативної адреси, замість підпису скриньки використовується призначений їй підпис. Альтернативні адреси, залишені на «Основний (за замовчуванням)», використовують підпис скриньки."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Видалити",
      "AVATAR_DELETE_BUTTON_TEXT": "Видалити аватар",
      "CONFIRM": {
        "TITLE": "Підтвердження видалення",
        "MESSAGE": "Справді бажаєте видалити ",
        "PLACE_HOLDER": "Будь ласка, введіть {inboxName} для підтвердження",
        "YES": "Так, видалити ",
        "NO": "Ні, залишити "
      },
      "API": {
        "SUCCESS_MESSAGE": "Скриньку успішно видалено",
        "ERROR_MESSAGE": "Не вдалося видалити скриньку \"Вхідні\". Будь ласка, спробуйте ще раз.",
        "AVATAR_SUCCESS_MESSAGE": "Аватар для джерела повідомлень успішно видалено",
        "AVATAR_ERROR_MESSAGE": "Не вдалося видалити аватар \"Джерела\". Будь ласка, спробуйте ще раз пізніше.",
        "MARKED_FOR_DELETION_MESSAGE": "Інбокс позначено для видалення",
        "RESTORE_SUCCESS_MESSAGE": "Інбокс успішно відновлено",
        "RESTORE_ERROR_MESSAGE": "Не вдалося відновити інбокс. Будь ласка, спробуйте пізніше."
      },
      "DELETE_REQUESTED_TOOLTIP": "Цей інбокс позначено для видалення",
      "RESTORE_BUTTON_TEXT": "Відновити"
    },
    "TABS": {
      "SETTINGS": "Налаштування",
      "COLLABORATORS": "Співавтори",
      "CONFIGURATION": "Конфігурація",
      "CAMPAIGN": "Розсилка",
      "PRE_CHAT_FORM": "Форма, що показується перед стартом діалогу",
      "BUSINESS_HOURS": "Робочий час",
      "WIDGET_BUILDER": "Конструктор віджетів",
      "BOT_CONFIGURATION": "Налаштування бота",
      "AUTOMATIC_PRIORITY": "Автоматичний пріоритет",
      "AUTOMATIC_LABELING": "Автоматичне маркування",
      "SLA": "SLA"
    },
    "SETTINGS": "Налаштування",
    "FEATURES": {
      "LABEL": "Особливості",
      "DISPLAY_FILE_PICKER": "Показувати вибір файлу на віджеті",
      "DISPLAY_EMOJI_PICKER": "Відображати емодзі на віджеті",
      "ALLOW_END_CONVERSATION": "Дозволити користувачам завершити розмову з віджета",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Показувати кнопку «Почати нову розмову» в шапці віджета",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Приховати поле вводу, коли відображається кнопка почати нову розмову",
      "SHOW_HANDOFF_BUTTON": "Показувати кнопку «Передати оператору» в шапці віджета",
      "USE_INBOX_AVATAR_FOR_BOT": "Вкажіть ім'я та аватар для бота",
      "ALLOW_OFFLINE_REPLY": "Дозволити агентам надсилати повідомлення, коли контакт офлайн і безперервність email недоступна",
      "AUTO_CLOSE_OLD": "Позначати всі попередні виклики з того ж номера як вирішені після вирішення одного",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Автоматично призначати пропущені виклики під час здійснення вихідного виклику"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Скрипт месенджера",
      "MESSENGER_SUB_HEAD": "Добавте кнопку на сторінки вашого сайту",
      "INBOX_AGENTS": "Агенти",
      "INBOX_AGENTS_SUB_TEXT": "Додати або вилучити агентів з скриньки Вхідні",
      "AGENT_ASSIGNMENT": "Призначення до розмови",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Оновити налаштування призначення для бесіди",
      "UPDATE": "Оновити",
      "ENABLE_EMAIL_COLLECT_BOX": "Включити збір електронної пошти",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Увімкнути або вимкнути ящик збору повідомлень в новій розмові",
      "AUTO_ASSIGNMENT": "Увімкнути автопризначення",
      "ENABLE_CSAT": "Увімкнути CSAT",
      "SENDER_NAME_SECTION": "Увімкнути ім'я співробітника в електронній пошті",
      "ENABLE_CSAT_SUB_TEXT": "Увімкнути/Вимкнути опитування CSAT(Задоволення клієнтів) після вирішення розмови",
      "SENDER_NAME_SECTION_TEXT": "Увімкнути/Вимкнути показ імені співробітника в електронній пошті, якщо це вимкнено, то буде відображатися бізнес-ім'я",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Увімкнути безперервність розмови через електронну пошту",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Розмови продовжуватимуться через електронну пошту, якщо доступна контактна адреса.",
      "RESPOND_FROM_EMAIL": "Відповідати з поштової скриньки",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "Листи клієнту — як відповіді, так і транскрипти розмов — надсилаються через SMTP-налаштування вибраної поштової скриньки, з вибраної адреси (власної адреси скриньки або однієї з її аліасів), а відповіді клієнта надходять назад через її IMAP-адресу.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Транскрипти розмов надсилаються через SMTP-налаштування вибраної поштової скриньки, з вибраної адреси (власної адреси скриньки або однієї з її аліасів), а відповіді надходять назад через її IMAP-адресу.",
      "LOCK_TO_SINGLE_CONVERSATION": "Заблокувати бесіду",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Увімкнути або вимкнути кілька бесід для одного контакту в цій папці Вхідні",
      "INBOX_UPDATE_TITLE": "Налаштування каналу",
      "INBOX_UPDATE_SUB_TEXT": "Оновіть параметри каналу",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Увімкнення або вимкнення автоматичного призначення нових розмов до агентів, доданих до цього каналу.",
      "HMAC_VERIFICATION": "Перевірка ідентифікації користувача",
      "HMAC_DESCRIPTION": "З цим ключем можна створити секретний токен, який можна використовувати для підтвердження особи ваших користувачів.",
      "HMAC_LINK_TO_DOCS": "Детальніше тут...",
      "HMAC_MANDATORY_VERIFICATION": "Застосувати примусову перевірку особистості користувача",
      "HMAC_MANDATORY_DESCRIPTION": "Якщо увімкнено, заявки, які не можна підтвердити, будуть відхилені.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Примусово починати нову розмову під час кожного завантаження віджета",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Якщо ввімкнено, відкриття віджета в новій вкладці або вікні починає нову розмову.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Забувати контакт під час початку нової розмови",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Якщо вимкнено, нова розмова, розпочата з віджета, зберігає попередній контакт.",
      "INBOX_IDENTIFIER": "Ідентифікатор каналу",
      "INBOX_IDENTIFIER_SUB_TEXT": "Використовуйте токен `inbox_identifier`, показаний тут для аутентифікації ваших API клієнтів.",
      "FORWARD_EMAIL_TITLE": "Переслати на ел. пошту",
      "FORWARD_EMAIL_SUB_TEXT": "Почніть перенаправляти листи до наступної адреси електронної пошти.",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Дозволити повідомлення після закінчення розмови",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Дозволити кінцевим користувачам надсилати повідомлення навіть після закриття розмови.",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Оновити параметри форми чату",
      "INBOX_TEAMS": "Команди",
      "INBOX_COOPERATORS": "Співробітники",
      "SELECT_PLACEHOLDER": "Виберіть",
      "AGENTS_OR_TEAMS_INFO": "Ви можете призначити або агентів, або команди — не обидва одночасно.",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Увімкнути CSAT для кожного повідомлення",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Увімкнути/вимкнути опцію опитування CSAT для кожного повідомлення, надісланого агентами",
      "SHOW_WELCOME_SCREEN": "Показувати вітальний екран",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Показувати вітальний екран при відкритті віджета. Якщо вимкнено, віджет одразу переходитиме до перегляду розмови.",
      "AUTO_CLOSE_PENDING": "Автоматично вирішувати чати з ШІ через (годин)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Автоматично вирішувати чати з ШІ після X годин неактивності.",
      "HMAC_ROTATE": {
        "BUTTON": "Змінити ключ",
        "TITLE": "Змінити секретний ключ?",
        "WARNING": "Поточний ключ втрачає чинність одразу після зміни.",
        "WARNING_DETAIL": "Перехідного періоду немає, і ключ не можна відновити.",
        "IMPACT": "Ваші сервери повинні підписувати користувачів новим ключем. Ті, хто досі підписаний старим ключем, не пройдуть перевірку. Якщо перевірка особистості користувача обов'язкова, вони не зможуть почати розмову.",
        "CONFIRM": "Змінити ключ",
        "CANCEL": "Скасувати",
        "SUCCESS": "Секретний ключ успішно змінено",
        "ERROR": "Не вдалося змінити секретний ключ, спробуйте ще раз"
      },
      "EMAIL_FETCHING_ENABLED_TITLE": "Синхронізація email",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Увімкнути автоматичну синхронізацію та завантаження вхідних листів з цього інбоксу",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Користувацький email-домен",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Увімкніть, щоб використовувати власний email-домен для вихідних листів",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Ви можете прочитати більше тут.",
      "FACEBOOK_COMMENTS_TITLE": "Коментарі Facebook",
      "WIDGET_STATUS_LABEL": "Статус віджета",
      "WIDGET_STATUS_ENABLED": "Увімкнено",
      "WIDGET_STATUS_BUSINESS_HOURS": "Увімкнено у робочі години",
      "WIDGET_STATUS_DISABLED": "Вимкнено",
      "WIDGET_STATUS_HELP_TEXT": "Керуйте, коли віджет показується відвідувачам вашого сайту",
      "EXPLICIT_CSAT_LOCALE": "Мова опитування CSAT та email",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Виберіть мову для всіх клієнтських email, включно з опитуваннями CSAT, стенограмами розмов та email-сповіщеннями",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Успадкувати від облікового запису",
      "WHATSAPP_CONNECTION": {
        "TITLE": "Підключення WhatsApp",
        "SUBTITLE": "Як цю скриньку підключено до WhatsApp.",
        "PROVIDER": "Провайдер",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Підключено через вбудовану реєстрацію Meta",
        "STATUS": "Статус",
        "CONNECTED": "Підключено",
        "RECONNECT_HINT": "Натисніть «Підключити знову» у сповіщенні вище.",
        "PHONE_NUMBER": "Номер телефону",
        "BUSINESS_ACCOUNT": "ID облікового запису WhatsApp Business",
        "OPEN_MANAGER": "Відкрити у WhatsApp Manager",
        "PHONE_NUMBER_ID": "ID номера телефону",
        "TEMPLATES": "Шаблони повідомлень",
        "TEMPLATES_COUNT": "Схвалено {approved} з {total}",
        "TEMPLATES_SYNCED": "Остання синхронізація: {date}",
        "TEMPLATES_NOT_SYNCED": "Ще не синхронізовано",
        "MANAGE_TEMPLATES": "Керувати шаблонами"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Довідковий центр",
      "PLACEHOLDER": "Виберіть довідковий центр",
      "SELECT_PLACEHOLDER": "Виберіть довідковий центр",
      "REMOVE": "Видалити довідковий центр",
      "SUB_TEXT": "Прикріпити Довідковий центр до папки Вхідні"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Ліміт автопризначення",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Будь ласка, введіть значення, більше за 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Обмеження максимальної кількості розмов із цього джерела, яку можна автоматично призначити агенту"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Повторна авторизація",
      "SUBTITLE": "Підключення до Facebook закінчилося, будь ласка, поновіть сторінку Facebook, щоб продовжити роботу служб",
      "MESSAGE_SUCCESS": "З'єднання пройшло успішно",
      "MESSAGE_ERROR": "Сталася помилка, будь ласка, спробуйте ще раз"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Попередні форми чату дозволяють зберегти інформацію про користувача, перш ніж вони почнуть розмову з вами.",
      "SET_FIELDS": "Поля, що відображаються перед початком діалогу",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Поля",
        "LABEL": "Мітка",
        "PLACE_HOLDER": "Мітка-заповнювач",
        "KEY": "Ключ",
        "TYPE": "Тип",
        "REQUIRED": "Обов'язково"
      },
      "ENABLE": {
        "LABEL": "Увімкнути форму попереднього чату",
        "OPTIONS": {
          "ENABLED": "Так",
          "DISABLED": "Ні"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Повідомлення, що відображається перед початком діалогу",
        "PLACEHOLDER": "Це повідомлення буде видимим для користувачів разом з формою"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Відвідувачі повинні надати своє ім'я та адресу електронної пошти перед початком чату"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Встановіть доступність",
      "SUBTITLE": "Встановіть доступність на вашому віджеті",
      "WEEKLY_TITLE": "Встановіть робочі години",
      "TIMEZONE_LABEL": "Обрати часовий пояс",
      "UPDATE": "Оновити налаштування робочих годин",
      "TOGGLE_AVAILABILITY": "Увімкнути робочі години для цього каналу",
      "UNAVAILABLE_MESSAGE_LABEL": "Повідомлення для відвідувачів у неробочі години",
      "TOGGLE_HELP": "Включення покаже робочі години на віджеті в чаті, навіть якщо всі агенти перебувають в автономному режимі. У неробочі години відвідувачі можуть бути попереджені повідомленням і формою попереднього чату.",
      "DAY": {
        "ENABLE": "Увімкнути доступність для цього дня",
        "UNAVAILABLE": "Неприсутній",
        "HOURS": "години",
        "VALIDATION_ERROR": "Час початку має бути менше часу закриття.",
        "CHOOSE": "Обрати"
      },
      "ALL_DAY": "Увесь день",
      "SAVE_TO_ALL": "Зберегти до всіх інбоксів",
      "SAVE_TO_ALL_TITLE": "Копіювати робочі години",
      "SAVE_TO_ALL_CONFIRM": "Налаштування з цієї форми (перемикач доступності, повідомлення про відсутність, часовий пояс та робочі години) буде скопійовано до всіх інших інбоксів, окрім email та телефонних інбоксів. Ви впевнені, що хочете продовжити?",
      "SAVE_TO_ALL_CANCEL": "Скасувати",
      "SAVE_TO_ALL_YES": "Так, скопіювати до всіх",
      "SAVE_TO_ALL_SUCCESS": "Робочі години успішно скопійовано до всіх інших інбоксів",
      "SAVE_TO_ALL_ERROR": "Не вдалося скопіювати робочі години до інших інбоксів"
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Встановити параметри IMAP",
      "NOTE_TEXT": "Для увімкнення SMTP, будь ласка, налаштуйте IMAP.",
      "UPDATE": "Оновити налаштування IMAP",
      "TOGGLE_AVAILABILITY": "Увімкнути налаштування IMAP для цієї папки Вхідні",
      "TOGGLE_HELP": "Увімкнення IMAP допоможе користувачу отримувати електронну пошту",
      "EDIT": {
        "SUCCESS_MESSAGE": "Налаштування IMAP успішно оновлено",
        "ERROR_MESSAGE": "Не вдалося оновити налаштування IMAP"
      },
      "ADDRESS": {
        "LABEL": "Адреса",
        "PLACE_HOLDER": "Адреса (наприклад: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Порт",
        "PLACE_HOLDER": "Порт"
      },
      "LOGIN": {
        "LABEL": "Увійти",
        "PLACE_HOLDER": "Увійти"
      },
      "PASSWORD": {
        "LABEL": "Пароль",
        "PLACE_HOLDER": "Пароль"
      },
      "ENABLE_SSL": "Увімкнути SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Повторно авторизувати Ваш обліковий запис MICROSOFT"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Встановити параметри SMTP",
      "UPDATE": "Оновити налаштування SMTP",
      "TOGGLE_AVAILABILITY": "Увімкнути SMTP конфігурацію для вхідних повідомлень",
      "TOGGLE_HELP": "Включення SMTP допоможе користувачеві надіслати email повідомлення",
      "EDIT": {
        "SUCCESS_MESSAGE": "Налаштування SMTP успішно оновлено",
        "ERROR_MESSAGE": "Неможливо оновити налаштування SMTP"
      },
      "ADDRESS": {
        "LABEL": "Адреса",
        "PLACE_HOLDER": "Адреса (наприклад: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Порт",
        "PLACE_HOLDER": "Порт"
      },
      "LOGIN": {
        "LABEL": "Увійти",
        "PLACE_HOLDER": "Увійти"
      },
      "PASSWORD": {
        "LABEL": "Пароль",
        "PLACE_HOLDER": "Пароль"
      },
      "DOMAIN": {
        "LABEL": "Домен",
        "PLACE_HOLDER": "Домен"
      },
      "ENCRYPTION": "Шифрування",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Режим підтвердження Open SSL",
      "AUTH_MECHANISM": "Автентифікація"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Доставка пошти (DNS)",
      "SUB_TITLE": "Кожного робочого дня ми перевіряємо записи SPF, DKIM, DMARC і MX домену {domain}. Якщо через щось сервери-одержувачі відхиляють ваші відповіді або позначають їх як спам, адміністратори отримають лист із рішенням.",
      "RUN": "Запустити перевірку",
      "RUN_SUCCESS": "Перевірку DNS завершено",
      "RUN_ERROR": "Не вдалося запустити перевірку DNS, спробуйте ще раз",
      "NOT_CHECKED": "Ще не перевірено.",
      "CHECKED_AT": "Остання перевірка: {time}.",
      "DNS_UNAVAILABLE": "Під час останньої перевірки сервери імен домену не відповіли. Результат нижче — з попередньої перевірки.",
      "SENDER": {
        "SMTP": "Відповіді надсилаються через {host}.",
        "PLATFORM": "Відповіді надсилаються через наші поштові сервери."
      },
      "STATUS": {
        "OK": "Усі записи в порядку",
        "WARNING": "Деякі записи можна поліпшити",
        "ERROR": "Відповіді можуть не доходити до одержувачів",
        "UNKNOWN": "Невідомо"
      },
      "SEVERITY": {
        "ERROR": "Проблема",
        "WARNING": "Попередження"
      },
      "FIX": "Виправте це за допомогою такого DNS-запису:",
      "RECORD_TYPE": "Тип",
      "RECORD_HOST": "Назва",
      "RECORD_VALUE": "Значення",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "SPF-запис відсутній",
          "DESCRIPTION": "Домен не вказує, які сервери можуть надсилати його пошту. Через це багато поштових серверів вважають ваші відповіді спамом. Додайте SPF-запис, який дозволяє {sender}."
        },
        "spf_multiple": {
          "TITLE": "Домен має SPF-записів: {count}",
          "DESCRIPTION": "Домен може мати лише один SPF-запис. Якщо їх більше, сервери-одержувачі ігнорують SPF і часто відхиляють пошту. Об'єднайте їх в один запис."
        },
        "spf_not_authorized": {
          "TITLE": "SPF не дозволяє сервер, який надсилає ваші відповіді",
          "DESCRIPTION": "Ваші відповіді надсилаються через {sender}, але SPF-запис домену його не містить. Поточний запис: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "SPF-запис потребує забагато DNS-запитів",
          "DESCRIPTION": "Сервери-одержувачі припиняють перевірку SPF після {limit} DNS-запитів, а {sender}, який надсилає ваші відповіді, зустрічається лише після {lookups}. Ваші відповіді не проходять SPF. Перенесіть {sender} на початок запису та видаліть include, які домен більше не використовує."
        },
        "spf_lookups_others": {
          "TITLE": "Деякі відправники в SPF-записі виходять за ліміт DNS-запитів",
          "DESCRIPTION": "SPF-запису потрібно DNS-запитів: {lookups}, а сервери-одержувачі зупиняються після {limit}. Ваші відповіді перевіряються вчасно й проходять SPF, але пошта від цих відправників його не проходить: {senders}. Видаліть include, які домен більше не використовує."
        },
        "spf_malformed": {
          "TITLE": "SPF-запис пошкоджено",
          "DESCRIPTION": "Сервери-одержувачі не можуть прочитати SPF-запис домену, тож він не захищає ваші відповіді. Проблема в: {terms}. Замініть запис виправленим."
        },
        "dkim_missing": {
          "TITLE": "Підпис DKIM не налаштовано",
          "DESCRIPTION": "Ми не знайшли ключ DKIM за адресою {selectors}. Без нього ваші відповіді не підписуються і частіше потрапляють у спам. Увімкніть підписування DKIM для домену у вашого поштового провайдера."
        },
        "dmarc_missing": {
          "TITLE": "DMARC-запис відсутній",
          "DESCRIPTION": "Великі поштові сервіси, як-от Gmail і Microsoft, очікують DMARC-запис. Без нього ваші відповіді частіше потрапляють у спам."
        },
        "dmarc_fails": {
          "TITLE": "DMARC вимагає від одержувачів відхиляти ваші відповіді",
          "DESCRIPTION": "Політика DMARC домену — «{policy}», а ваші відповіді не проходять ні SPF, ні DKIM, тому одержувачі відхиляють їх або переміщують у спам. Виправте SPF і DKIM, описані вище."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC блокує відповіді, надіслані через наші поштові сервери",
          "DESCRIPTION": "Ця скринька надсилає відповіді через наші поштові сервери, але політика DMARC домену — «{policy}», тому одержувачі відхиляють їх або переміщують у спам. Налаштуйте для цієї скриньки SMTP власного поштового сервера."
        },
        "mx_missing": {
          "TITLE": "Домен не має MX-запису",
          "DESCRIPTION": "Без MX-запису ніхто не може надсилати пошту на цей домен, тож клієнти не зможуть відповісти на ваші листи."
        }
      }
    },
    "NOTE": "Замітка: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Аватар веб-сайту",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Аватар успішно видалено",
              "ERROR_MESSAGE": "Сталася помилка, будь ласка, спробуйте ще раз"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Назва сайту",
          "PLACE_HOLDER": "Введіть назву свого сайту (наприклад: Acme Inc)",
          "ERROR": "Будь ласка введіть правильну назву сайту"
        },
        "WELCOME_HEADING": {
          "LABEL": "Заголовок",
          "PLACE_HOLDER": "Привіт!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Талін привітання",
          "PLACE_HOLDER": "Ми робимо це простим — запитуємо що-небудь чи поділіться своїми відгуками."
        },
        "REPLY_TIME": {
          "LABEL": "Час відповіді",
          "IN_A_FEW_MINUTES": "За кілька хвилин",
          "IN_A_FEW_HOURS": "За кілька годин",
          "IN_A_DAY": "Протягом дня"
        },
        "WIDGET_COLOR_LABEL": "Колір віджета",
        "WIDGET_BUBBLE_POSITION_LABEL": "Позиція віджету",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Максимальна висота непрочитаних повідомлень (px)",
          "PLACE_HOLDER": "Без обмежень",
          "HELP_TEXT": "Обмежте максимальну висоту спливаючого вікна непрочитаних повідомлень у пікселях. Залиште порожнім для типової поведінки (без обмежень)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Тип віджету",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Почніть розмову з нами",
          "LABEL": "Заголовок віджета",
          "PLACE_HOLDER": "Почніть розмову з нами"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Оновити налаштування віджета",
          "API": {
            "SUCCESS_MESSAGE": "Налаштування віджета успішно оновлені",
            "ERROR_MESSAGE": "Не вдалося оновити налаштування віджета"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Попередній перегляд",
          "SCRIPT": "Скрипт"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Ліворуч",
          "RIGHT": "Праворуч"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Стандартний",
          "EXPANDED_BUBBLE": "Розширена рамка сповіщення"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "За замовчуванням",
        "CHAT": "Чат"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Зазвичай відповідаємо за декілька хвилин",
        "IN_A_FEW_HOURS": "Зазвичай відповідаємо за декілька годин",
        "IN_A_DAY": "Зазвичай відповідаємо протягом доби"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Розпочати розмову",
        "CHAT_INPUT_PLACEHOLDER": "Введіть Ваше повідомлення"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Ми Онлайн",
          "OFFLINE": "Нас наразі немає"
        },
        "USER_MESSAGE": "Привіт",
        "AGENT_MESSAGE": "Доброго дня"
      },
      "BRANDING_TEXT": "Працює на JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Інші постачальники"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Вебсайт",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "EMAIL": "Email",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API канал",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "PHONE": "SIP-телефон",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    },
    "SLA": {
      "TITLE": "Політики SLA",
      "SUB_TEXT": "Налаштуйте час відповіді SLA та час вирішення для кожного рівня пріоритету розмови.",
      "LOADING": "Завантаження політик SLA...",
      "FIELDS": {
        "ACTIVE": "Активна",
        "TICKET_PRIORITY": "Пріоритет тікета",
        "FIRST_RESPONSE_TIME": "Час першої відповіді",
        "EVERY_RESPONSE_TIME": "Час кожної відповіді",
        "RESOLUTION_TIME": "Час вирішення",
        "PLACEHOLDER": "наприклад, 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "Політики SLA успішно оновлено.",
        "ERROR_MESSAGE": "Не вдалося оновити політики SLA. Будь ласка, спробуйте ще раз."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Автоматичний пріоритет",
      "SUB_TEXT": "Налаштуйте автоматичне призначення пріоритету на основі вмісту розмови.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Повідомлення про оплату",
        "MESSAGE": "Кожна оцінка пріоритету тарифікується. Будь ласка, перегляньте деталі вашого тарифу для інформації про ціни."
      },
      "MODE": {
        "OFF": "Вимкнено",
        "ALL_MESSAGES": "Увімкнено для всіх вхідних повідомлень",
        "FIRST_MESSAGE": "Увімкнено лише для першого вхідного повідомлення"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Конфігурація рівнів пріоритету",
        "SUB_TEXT": "Налаштуйте, які рівні пріоритету мають бути увімкнені, та їхні описи. Надайте чіткі критерії для ШІ, щоб визначити, коли цей пріоритет слід призначити."
      },
      "DESCRIPTION_LABEL": "Опис",
      "DESCRIPTION_PLACEHOLDER": "Опишіть розмови, які слід позначити як пріоритет {priority}",
      "SET_AS_DEFAULT": "Встановити як пріоритет за замовчуванням",
      "MULTIPLE_DEFAULTS_WARNING": "Лише один рівень пріоритету має бути встановлений за замовчуванням. Зніміть позначки з інших."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Автоматичне маркування",
      "SUB_TEXT": "Налаштуйте автоматичне призначення міток на основі вмісту розмови.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Повідомлення про оплату",
        "MESSAGE": "Кожна оцінка маркування тарифікується. Будь ласка, перегляньте деталі вашого тарифу для інформації про ціни."
      },
      "MODE": {
        "OFF": "Вимкнено",
        "CONVERSATION_OPEN": "Під час відкриття розмови",
        "CONVERSATION_CLOSE": "Під час закриття розмови",
        "ALL_MESSAGES": "При кожному повідомленні — незалежно від стану",
        "FIRST_MESSAGE": "При першому повідомленні — незалежно від стану"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Конфігурація міток",
        "SUB_TEXT": "Налаштуйте, які мітки мають бути доступні для автоматичного призначення, та їхні описи. Надайте чіткі критерії для ШІ, щоб визначити, коли цю мітку слід застосувати."
      },
      "DESCRIPTION_LABEL": "Опис",
      "DESCRIPTION_PLACEHOLDER": "Опишіть розмови, які слід позначати як {label}. Якщо ви залишите порожнім, буде використано опис мітки.",
      "NO_LABELS_MESSAGE": "Міток не знайдено. Створіть мітки, щоб увімкнути автоматичне маркування.",
      "CREATE_LABELS_LINK": "Створити мітки"
    },
    "PHONE": {
      "TITLE": "Налаштування телефону",
      "SUBTITLE": "Налаштуйте, які виклики відображатимуться в цьому інбоксі.",
      "UPDATE": "Зберегти налаштування",
      "EDIT": {
        "SUCCESS_MESSAGE": "Налаштування телефону оновлено",
        "ERROR_MESSAGE": "Не вдалося оновити налаштування телефону"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Номери телефонів",
        "SUBTITLE": "Введіть номери телефонів, що належать до цього інбоксу.",
        "PLACEHOLDER": "+145123908635",
        "ADD": "Додати номер телефону"
      }
    }
  }
}
